// function for validation cogs filters
export const validateCogsFilters = (cogsFilters) => {
  const filterObj = cogsFilters.values;
  const keys = Object.keys(filterObj);
  const isValid = keys.filter((ele) => {
    return filterObj[ele].length === 0;
  });
  return isValid.length > 0;
};
